/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Location } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { FrameworkDetails } from '../../models/admin/admin.model';
import { RestClientService } from '../rest-client.service';

@Injectable({ providedIn: 'root' })
export class FrameworkV3Service {
  private readonly restClient = inject(RestClientService);

  getFrameworks(): Observable<FrameworkDetails[]> {
    return this.restClient
      .get<FrameworkDetails[]>(Location.joinWithSlash(environment.apiRootUrl || '', 'frameworks/v3'))
      .pipe(map(({ body }) => body ?? []));
  }

  /** One framework with its tag tree. Unlike the list, any signed-in user may read it, learners included. */
  getFramework(frameworkUid: string): Observable<FrameworkDetails | null> {
    return this.restClient
      .get<FrameworkDetails>(Location.joinWithSlash(environment.apiRootUrl || '', `frameworks/${frameworkUid}`))
      .pipe(map(({ body }) => body ?? null));
  }
}
